export const USE_MOCKS = (process.env.REACT_APP_USE_MOCKS ?? 'false') === 'true';